import vuetifyToast from 'vuetify-toast'
import { baseActions, baseMutations } from '../base'
import { apiAxios } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'

const notify = (message) => {
  vuetifyToast.show({
    text: message,
    color: 'success',
    timeout: 2000,
    icon: 'check',
  })
}

const initialState = () => {
  return {
    module: 'languages',
    model: 'language',
    loading: false,

    list: [],
    selected: {
      active: true,
      name: [],
      iso: '',
      order: '',
    },
    idSelected: '',
    iso: () =>
      localStorage.getItem('iso') ||
      localStorage.getItem('defaultISO') ||
      'es-ES',
    locale: () => localStorage.getItem('locale') || 'es',
    defaultISO: localStorage.getItem('defaultISO') || 'es-ES',
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 0,
      totalItems: 0,
    },
  }
}

const state = initialState()

const getters = {
  selectList(state) {
    let activeList = state.list.filter((item) => item.active)
    return activeList.map((item) => ({
      value: item._id,
      text: item.name,
    }))
  },
  formatedList(state) {
    return state.list.map((item) => {
      let result = {
        _id: item._id,
        active: item.active,
        name: item.name,
        text: item.text,
        order: item.order,
        iso: item.iso,
        createdAt: formatDate(item.createdAt, true),
        createdBy: item.createdBy
          ? item.createdBy.name + ' ' + item.createdBy.lastname1
          : '-',
      }
      return result
    })
  },
}

const actions = {
  ...baseActions,
  async update({ dispatch, commit, state }, payload) {
    commit('setLoading', true)
    const iso = payload.iso
    const { data } = await apiAxios
      .put(`${state.module}/${iso}`, payload)
      .finally(() => commit('setLoading', false))
    notify(data.message)
    dispatch('fetchList')
    const item = data.data ? data.data[state.model] : {}
    return item
  },
}

const mutations = {
  ...baseMutations,
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
